import Switch from '@mui/material/Switch/Switch';
import FormControlLabel from '@mui/material/FormControlLabel/FormControlLabel';
import { FormControlSwitchProps, FormElementControlPropsType } from './index';
import useBundleTranslation from 'i18n';
import IconMi from 'components/common/icon/IconMi';
import React from 'react';
import { Box, FormLabel, Tooltip } from '@mui/material';
import showdown from 'showdown';

const converter = new showdown.Converter();

function SwitchLabel({ controlProps, elementProps }: FormElementControlPropsType<FormControlSwitchProps>) {
    const { t } = useBundleTranslation([elementProps?.translationNS ?? 'components/common/form/form']);
    const statusLabel = controlProps.checked ? controlProps.onLabel : controlProps.offLabel;
    if (typeof statusLabel == 'object') {
        const main = t(statusLabel?.main ?? '');
        const secondary = t(statusLabel?.secondary ?? '');
        return (
            <span>
                {main && (
                    <>
                        <strong>{main}</strong>{' '}
                    </>
                )}
                {secondary}
            </span>
        );
    } else {
        let label = typeof statusLabel == 'string' ? statusLabel : controlProps.label;
        if (typeof label == 'string' && controlProps.translate) {
            label = t(label);
        }
        return (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box component="span" className={controlProps.labelClass}>
                    {label}
                </Box>
                {controlProps?.tooltip?.icon && (
                    <Tooltip
                        placement={'top'}
                        title={
                            <Box
                                sx={{ '& p': { m: 0 } }}
                                dangerouslySetInnerHTML={{
                                    __html: converter.makeHtml(String(t(controlProps.tooltip.icon))),
                                }}
                            />
                        }
                    >
                        <Box sx={{ display: 'inline-flex', ml: 0.5, color: 'primary.main', fontSize: '16px' }}>
                            <IconMi icon="info-circle" fontSize="16" />
                        </Box>
                    </Tooltip>
                )}
            </Box>
        );
    }
}

export default function FormSwitch({
    controlProps,
    elementProps,
}: FormElementControlPropsType<FormControlSwitchProps>) {
    return (
        <FormControlLabel
            label={<SwitchLabel controlProps={controlProps} elementProps={elementProps} />}
            className={'form-switch'}
            sx={{
                alignSelf: 'flex-start',
            }}
            control={
                <Switch
                    data-test={controlProps.uid}
                    name={controlProps.name}
                    disabled={controlProps.disabled}
                    onChange={controlProps.onChange}
                    checked={controlProps.checked}
                    color={elementProps?.componentProps?.color}
                    data-test-value={controlProps.checked}
                />
            }
        />
    );
}
